import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import {
  UpdateCustomFieldValuesForAccountMutation as _UpdateCustomFieldValuesForAccountMutation,
  UpdateCustomFieldValuesForAccountInput,
} from '@/gql/graphql';

const UpdateCustomFieldValuesForAccountMutation = graphql(`
  mutation UpdateCustomFieldValuesForAccount(
    $input: UpdateCustomFieldValuesForAccountInput!
  ) {
    updateCustomFieldValuesForAccount(input: $input) {
      id
    }
  }
`);

const useUpdateCustomFieldValuesForAccount = (
  options?: UseMutationOptions<
    _UpdateCustomFieldValuesForAccountMutation,
    unknown,
    UpdateCustomFieldValuesForAccountInput
  >
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};
  return useMutation({
    mutationFn: (variables) =>
      gqlClient.request(UpdateCustomFieldValuesForAccountMutation, {
        input: variables,
      }),
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountCustomFields(),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useUpdateCustomFieldValuesForAccount;
